import { Input } from "components/ui/input";
import { Search, X } from "lucide-react";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { useNavigate, useSearchParams } from "react-router-dom";
import { setBtnSearch, setBtnSearchStaff } from "store/header";
import { useAppSelector } from "store/store";

interface SearchBarType {
  onValueChange: (value: string) => void;
  name?: string;
  className?: string;
  placeholder?: string;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  navigateUrlWhenEnter?: string;
  isSearchBarHeader?: boolean;
  onHideSuggestions?: () => void;
}

export default function SearchBar({
  onHideSuggestions,
  onValueChange,
  name,
  className,
  placeholder = "Search",
  onFocus,
  onBlur,
  navigateUrlWhenEnter = "/search",
  isSearchBarHeader = false,
}: SearchBarType) {
  const dispatch = useDispatch();
  const [searchTextInput, setSearchTextInput] = useState<string>("");
  const [searchParams] = useSearchParams();
  const searchTextParam: any = searchParams.get("search_text");
  const [delayedValue, setDelayedValue] = useState<string>("");
  const navigate = useNavigate();
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTextInput(event.target.value);
  };

  useEffect(() => {
    // console.log(searchTextParam, "dddd");

    // Set a timeout for delayed value change
    if (onFocus) {
      setDelayedValue(searchTextInput);
    } else {
      const handler = setTimeout(() => {
        setDelayedValue(searchTextInput);
      }, 1000);

      // Cleanup the timeout if searchTextInput changes before the timeout is complete
      return () => {
        clearTimeout(handler);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTextInput]);

  useEffect(() => {
    if (delayedValue !== "") {
      onValueChange(delayedValue);
    } else {
      onValueChange(delayedValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delayedValue]);

  useEffect(() => {
    if (searchTextParam && isSearchBarHeader) {
      setSearchTextInput(searchTextParam);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTextParam]);
  const { bntSearch } = useAppSelector((state) => state.header);

  return (
    <div className={className}>
      <div className="relative">
        <Input
          name={name}
          type="text"
          autoComplete="new-password"
          placeholder={placeholder}
          className={`w-full h-full px-4   py-2 rounded-full shadow focus:outline-none`}
          value={searchTextInput}
          onChange={handleInputChange}
          onFocus={onFocus}
          onBlur={onBlur}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              onHideSuggestions?.();
              if (navigateUrlWhenEnter !== "/search") {
                navigate(`${navigateUrlWhenEnter}`);
              }
            }
          }}
        />
        <span className="absolute inset-y-0 right-0 flex items-center pr-3">
          {searchTextInput === "" ? (
            <Search
              className=" cursor-pointer"
              onClick={() => {
                dispatch(setBtnSearch(!bntSearch));
              }}
            />
          ) : (
            <X
              className="z-30 cursor-pointer bg-black text-white p-1 rounded-full"
              onClick={() => {
                // dispatch(setSearchTextInput(""));
                setSearchTextInput("");
                onValueChange("");
                if (isSearchBarHeader) {
                  const searchParamsUrl = new URLSearchParams(window.location.search);
                  searchParamsUrl.set("search_text", "");

                  // Update the URL without refreshing the page
                  const newUrl = `${window.location.pathname}?${searchParamsUrl.toString()}`;
                  window.history.pushState({}, "", newUrl);
                }
              }}
            />
          )}
        </span>
      </div>
    </div>
  );
}
